import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import experienceData from '../../assets/EDXP_data/experience.json';
import educationData from '../../assets/EDXP_data/education.json';
import researchData from '../../assets/EDXP_data/research.json';
import SectionHeading from '../home/SectionHeading';
import '../home/home.css';

const ease = [0.23, 1, 0.32, 1] as const;

const currentRole = experienceData[0];
const previousRole = experienceData[1];
const latestEducation = educationData[0];
const thesis = researchData[0];

type HeroAtAGlanceProps = {
  embedded?: boolean;
};

const HeroAtAGlance = ({ embedded = false }: HeroAtAGlanceProps) => {
  const content = (
    <>
      <SectionHeading title="At a glance" />

      <div className="home-section-body">
        <motion.div
          className="home-ledger"
          id="AtAGlance"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease }}
        >
          <div className="home-ledger-row">
            <span className="home-ledger-label">Now</span>
            <div className="home-ledger-content">
              <div className="home-ledger-head">
                <h3 className="home-ledger-title">
                  {currentRole.desg}, {currentRole.company}
                </h3>
                <a
                  className="home-inline-link"
                  href={currentRole.website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Company site
                  <ArrowUpRight />
                </a>
              </div>
              <p className="home-ledger-kicker">{currentRole.years}</p>
              <p className="home-ledger-copy">{currentRole.desc}</p>
              <ul className="home-ledger-points">
                {currentRole.resps.slice(0, 3).map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </div>
          </div>

          {previousRole && (
            <div className="home-ledger-row">
              <span className="home-ledger-label">Before</span>
              <div className="home-ledger-content">
                <h3 className="home-ledger-title">
                  {previousRole.desg}, {previousRole.company}
                </h3>
                <p className="home-ledger-kicker">{previousRole.years}</p>
                <p className="home-ledger-copy">{previousRole.desc}</p>
              </div>
            </div>
          )}

          <div className="home-ledger-row">
            <span className="home-ledger-label">Education</span>
            <div className="home-ledger-content">
              <h3 className="home-ledger-title">{latestEducation.degree}</h3>
              <p className="home-ledger-kicker">
                {latestEducation.institute}, {latestEducation.years.replace(' - ', '–')}
              </p>
            </div>
          </div>

          {thesis && (
            <div className="home-ledger-row">
              <span className="home-ledger-label">Research</span>
              <div className="home-ledger-content">
                <div className="home-ledger-head">
                  <h3 className="home-ledger-title">LBEADS-NET</h3>
                  <a
                    className="home-inline-link"
                    href={thesis.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read thesis
                    <ArrowUpRight />
                  </a>
                </div>
                <p className="home-ledger-copy">
                  Algorithm unrolling for learned baseline estimation and denoising in
                  chromatographic signals. Master&apos;s thesis, NYU Tandon.
                </p>
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </>
  );

  if (embedded) {
    return <div className="home-about-module home-snapshot">{content}</div>;
  }

  return (
    <section className="home-section home-snapshot" id="AtAGlance">
      <div className="home-section-inner">{content}</div>
    </section>
  );
};

export default HeroAtAGlance;
